<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-8="$vuetify.breakpoint.lgAndUp">
        <v-layout row wrap justify-center align-baseline>
          <v-flex xs12 sm12 md11 lg11>
            <v-card class="rounded-lg" v-if="errorHide">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-title>
                  {{ $t("petition.text11") }} <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-6">
                  <v-layout row wrap align-center justify-start>
                    <v-flex xs12 lg12
                      ><b>{{ $t("petition.text26") }}</b></v-flex
                    >
                    <v-flex xs12 lg12>
                      <v-card
                        outlined
                        color="rgb(228 228 228)"
                        style="text-indent: 1rem"
                      >
                        <v-card-text
                          ><b>{{ $t("petition.text25") }}</b></v-card-text
                        >
                      </v-card>
                    </v-flex>
                    <v-flex xs12 lg6 pa-1>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("petition.text27") }}</b> <br />
                      <v-select
                        outlined
                        dense
                        color="#077893"
                        return-object
                        clearable
                        :filled="Pettition === 'pending'"
                        :disabled="Pettition === 'pending'"
                        :items="TypeRequest"
                        item-text="Name"
                        item-value="TypeRequestId"
                        v-model="SelectValueType"
                        :rules="[(v) => !!v || $t('petition.text34')]"
                      ></v-select>
                      <!-- {{ SelectValueType }} -->
                    </v-flex>
                    <v-flex xs12 lg6 pa-1>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("Profile.fileUpload") }}</b> <br />
                      <v-file-input
                        accept=".pdf, image/png, image/jpeg"
                        multiple
                        dense
                        v-model="files"
                        :filled="Pettition === 'pending'"
                        :disabled="Pettition === 'pending'"
                        color="#077893"
                        counter
                        prepend-icon=""
                        outlined
                        show-size
                        :rules="rules"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="#077893"
                            dark
                            label
                            small
                          >
                            {{ text }}
                          </v-chip>
                          <span
                            v-else-if="index === 2"
                            class="text-overline grey--text text--darken-3 mx-2"
                          >
                            +{{ files.length - 2 }} File(s)
                          </span>
                        </template>
                      </v-file-input>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex xs12 lg12 ma-2 mt-n2>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("petition.text28") }}</b> <br />
                      <v-card outlined class="mt-1">
                        <v-card-text>
                          <v-data-table
                            calculate-widths
                            hide-default-footer
                            dense
                            :headers="headers"
                            :items="Tag"
                            class="elevation-0"
                          >
                            <template v-slot:[`item.checkbox`]="{ item }">
                              <div>
                                <v-checkbox
                                  @change="CheckMessage(item)"
                                  @click="
                                    item.checkbox = !item.checkbox
                                      ? true
                                      : false
                                  "
                                  :disabled="
                                    item.Status == false ||
                                    item.Status == 'pending' ||
                                    item.Status == 'approve'
                                  "
                                  color="#077893"
                                  v-model="ItemPetition"
                                  :value="item"
                                ></v-checkbox>
                              </div>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <v-text-field
                                @input="CheckMessage(item)"
                                :error-messages="item.messageerror"
                                :disabled="
                                  item.Status == false ||
                                  item.Status == 'pending' ||
                                  item.Status == 'approve' ||
                                  item.checkbox == false ||
                                  item.checkbox == null
                                "
                                color="#077893"
                                class="my-5"
                                outlined
                                dense
                                hide-details
                                v-model="item.ReqMessage"
                              ></v-text-field>
                              <v-chip
                                label
                                class="mt-n5"
                                v-if="item.Status === 'unapprove'"
                                color="error"
                                small
                                dark
                              >
                                <v-icon small left> mdi-nature </v-icon> เหตุผล
                                : {{ item.CanReasons }}</v-chip
                              >
                            </template>
                            <template v-slot:[`item.note`]="{ item }">
                              <v-chip
                                v-if="item.Status === 'approve'"
                                color="purple"
                                small
                                dark
                              >
                                {{ $t("consentlist.status4") }}
                              </v-chip>
                              <v-chip
                                v-else-if="item.Status === 'unapprove'"
                                color="red"
                                small
                                dark
                              >
                                ปฎิเสธคำร้อง
                              </v-chip>
                              <v-chip
                                v-else-if="item.Status === 'true'"
                                color="teal"
                                small
                                dark
                              >
                                {{ $t("petition.text22v2") }}
                              </v-chip>
                              <v-chip
                                v-else-if="item.Status === 'false'"
                                color="info"
                                small
                                dark
                              >
                                {{ $t("petition.text39") }}</v-chip
                              >
                              <v-chip
                                v-else-if="item.Status === 'wait'"
                                color="info"
                                small
                                dark
                              >
                                {{ $t("consentlist.status3") }}</v-chip
                              >
                              <v-chip
                                v-else-if="item.Status === 'pending'"
                                color="warning"
                                small
                                dark
                              >
                                {{ $t("petition.text38") }}</v-chip
                              >
                              <!-- <v-chip
                                v-if="item.Step === '4'"
                                color="purple"
                                small
                                dark
                              >
                                {{ $t("consentlist.status4") }}
                              </v-chip> -->
                            </template>
                            <template v-slot:[`item.DueDate`]="{ item }">
                              <div v-if="item.DueDate == ''">-</div>
                              <div v-else>
                                {{ item.DueDate }}
                              </div>
                            </template>
                            <template v-slot:[`item.ReqDtm`]="{ item }">
                              <div v-if="item.ReqDtm == ''">-</div>
                              <div v-else>
                                {{ item.ReqDtm }}
                              </div>
                            </template>
                            <template v-slot:[`item.Step`]="{ item }">
                              <v-tooltip top color="rgb(0 0 0 / 0%)">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="#077893"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-tooltip-text
                                  </v-icon>
                                </template>
                                <v-stepper
                                  :value="item.Step"
                                  class="mt-12"
                                  alt-labels
                                  width="80vh"
                                >
                                  <v-stepper-header>
                                    <v-stepper-step step="1" color="teal">
                                      <div
                                        class="text-center"
                                        style="font-size: 12px"
                                      >
                                        {{ $t("consentlist.status1") }}
                                      </div>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="2" color="info">
                                      <div
                                        class="text-center"
                                        style="font-size: 12px"
                                      >
                                        {{ $t("consentlist.status2") }}
                                      </div>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="3" color="indigo">
                                      <div
                                        class="text-center"
                                        style="font-size: 12px"
                                      >
                                        {{ $t("consentlist.status3") }}
                                      </div>
                                    </v-stepper-step>
                                    <v-divider></v-divider>
                                    <v-stepper-step step="4" color="purple">
                                      <div
                                        class="text-center"
                                        style="font-size: 12px"
                                      >
                                        {{ $t("consentlist.status4") }}
                                      </div>
                                    </v-stepper-step>
                                  </v-stepper-header>
                                </v-stepper>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="pb-5 pa-3">
                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn color="error" outlined @click="Fn_Close()" dark>
                {{ $t("consentform.close") }}
              </v-btn> -->
                  <v-layout row wrap align-baseline justify-center>
                    <div class="text-center">
                      <v-btn
                        :dark="Pettition != 'pending'"
                        color="#077893"
                        @click="Request_Cancel"
                        :loading="loading"
                        :disabled="Pettition === 'pending'"
                      >
                        {{ $t("consentlist.petitionBtn") }}
                      </v-btn>
                    </div>
                  </v-layout>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
// import authorization from "@/functions/authorization.js";
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      valid: true,
      loadingDownloadData: false,
      getData: [],
      Tag: [],
      Pettition: '',
      SubjectRequest: '',
      loading: false,
      dis: false,
      name: '',
      surname: '',
      phone: '',
      email: '',
      SelectValueType: '',
      TypeRequest: '',
      rules: [
        (v) => !!v || 'กรุณาแนบไฟล์เพื่อยืนยันข้อมูล',
        (v) => (v && v.length > 0) || 'กรุณาแนบไฟล์เพื่อยืนยันข้อมูล'
      ],
      singleSelect: false,
      selected: [],
      SelectNameRequest: '',
      ItemPetition: [],
      checkbox: false,
      btnLoad: false,
      messageerror: 'กรุณากรอกชื่อ',
      files: [],
      previousFiles: [],
      myStr: [],
      errorHide: true,
      hover: false,
      textStep: [
        { text: 'กำลังใช้งาน', num: '1' },
        { text: 'ยื่นคำร้องสำเร็จ', num: '2' },
        { text: 'วันที่จะดำเนินการพิจารณา', num: '3' },
        { text: 'คำร้องได้รับการอนุมัติ', num: '4' }
      ]
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$i18n.t('NewUpdate.use'),
          value: 'checkbox',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$i18n.t('NewUpdate.dataRequest'),
          value: 'Key',
          sortable: false,
          align: 'left'
        },
        {
          text: this.$i18n.t('NewUpdate.reason'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$i18n.t('NewUpdate.status'),
          align: 'left',
          value: 'note',
          sortable: false
        },
        {
          text: this.$i18n.t('NewUpdate.ReqDtm'),
          align: 'center',
          value: 'ReqDtm',
          sortable: false
        },
        {
          text: this.$i18n.t('NewUpdate.text1'),
          align: 'center',
          value: 'DueDate',
          sortable: false
        },
        {
          text: 'ขั้นตอนการยื่นคำร้อง',
          align: 'center',
          value: 'Step',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    this.Fn_GetConsentEmail()
  },
  methods: {
    async CheckMessage (val) {
      if (val.ReqMessage === '') {
        val.messageerror = 'กรุณากรอกชื่อ'
      } else {
        val.messageerror = ''
      }
    },
    handleFileUpload (event) {
      const files = event.target.files
      const fileData = []

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const reader = new FileReader()

        reader.onload = (e) => {
          fileData.push({
            name: file.name,
            data: e.target.result
          })

          if (fileData.length === files.length) {
            // ทำสิ่งที่ต้องการกับข้อมูลไฟล์ที่ถูกอัพโหลดทั้งหมด
          }
        }

        reader.readAsDataURL(file)
      }
    },
    async Fn_GetConsentEmail () {
      this.loadingDownloadData = true
      var payload = {
        EmailId: this.$route.path.split('/')[2],
        Token: this.$route.path.split('/')[3]
      }
      // var Headers = {
      //   AccountId: this.$cookies.get("ChatAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'email/GetConsentEmail',
          payload
          // { Data: dataEncode },
          // { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status === 'OK') {
            this.getData = response.data.Message
            this.TypeRequest = response.data.Message.TypeRequest
            this.Tag = response.data.Message.Tag
            this.Pettition = response.data.Message.Pettition
            // if (this.Status === "OK") {
            //   this.NameBtnSave = "รับทราบประกาศรายการเรียบร้อยแล้ว";
            // } else if (this.Status === "WAIT") {
            //   this.NameBtnSave = "รับทราบ";
            // }
          } else {
            // window.close();
            this.errorHide = false
            Toast.fire({
              icon: 'error',
              // title: response.data.ErrorMessage,
              title: 'ข้อมูลที่ส่งมาไม่ถูกต้อง'
            })
          }
        })
        .catch((error) => {
          this.errorHide = false
          this.loadingDownloadData = false
          window.close()
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: 'ข้อมูลที่ส่งมาไม่ถูกต้อง'
              // title: error.response.data.ErrorMessage,
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: 'ข้อมูลที่ส่งมาไม่ถูกต้อง'
              // title: error.request,
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: 'ข้อมูลที่ส่งมาไม่ถูกต้อง'
              // title: error.message || error,
            })
          }
        })
    },
    async Request_Cancel () {
      const newData = this.ItemPetition.map((item) => {
        const { DueDate, checkbox, ...newItem } = item
        return newItem
      })
      this.myStr = JSON.stringify(newData)
      var checkText = newData.every((newData) => newData.messageerror === '')

      if (this.$refs.form.validate() && checkText === true) {
        this.loading = true
        var formData = new FormData()
        for (const i of this.files) {
          formData.append('File', i)
        }
        formData.append('SendId', this.getData.SendId)
        formData.append('AccountId', this.getData.AccountId)
        formData.append('TypeRequstId', this.SelectValueType.TypeRequestId)
        formData.append('BusinessId', this.getData.BusinessId)
        // formData.append("AccessToken", this.$cookies.get("OneAccessToken"));
        formData.append('Tag', this.myStr)
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              'email/RequestPetitionEmail',
            formData
          )
          .then((response) => {
            if (response.data.Status === 'OK') {
              this.loading = false
              Toast.fire({
                icon: 'success',
                title: response.data.Message
              })
              window.location.reload()
            } else {
              Toast.fire({
                icon: 'error',
                title: response.data.ErrorMessage
              })
              this.loading = false
            }
          })
          .catch((error) => {
            this.loading = false
            this.messageerror = 'กรุณากรอกชื่อ'
            if (error.response) {
              Toast.fire({
                icon: 'error',
                title: error.response.data.ErrorMessage
              })
            } else if (error.request) {
              Toast.fire({
                icon: 'error',
                title: error.request
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: error.message || error
              })
            }
          })
      } else {
        this.messageerror = 'กรุณากรอกชื่อ'
        Toast.fire({
          icon: 'error',
          title: this.$i18n.t('NewUpdate.text5')
        })
      }
    }
  },
  watch: {
    show (val) {
      if (val == true) {
        if (this.ItemPetition == '') {
          this.ItemPetition = []
          this.checkbox = false
          this.files = []
          this.SelectValueType = ''
          this.$refs.form.reset()
        }
      } else if (val == false) {
        val = false
      }
    }
  }
}
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
